<template>
  <div class="html-editor">
    <div class="editor" @dragover="dragOver" @drop="drop">
      <div class="trigger" @click="fold=!fold">{{fold?'展开':'收起'}}</div>
      <editor id="tinymce" v-model="value" :init="init"></editor>
    </div>
    <div class="dics" :class="{fold:fold}">
      <div class="dic"
        v-for="(dic,dicIdx) in dics"
        :key="dicIdx"
        draggable="true"
        @dblclick="()=>{addToEditor(dic.value)}"
        @dragstart="(e)=>{startDrag(e, dic.value)}">
        {{dic.key}}: {{dic.value}}
      </div>
    </div>
  </div>
</template>

<script>
import tinymce from 'tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/icons/default/icons.min.js'
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/wordcount'

export default {
  name: 'html-editor',
  components: {Editor},
  props: {
    content: String,
    dictionary: Array
  },
  data () {
    return {
      value: null,
      curDicText: null,
      curBookmark: null,
      init: {
        selector: '#tinymce', // tinymce的id
        placeholder: '编辑模板内容',
        height: '100%',
        language_url: '/tinymce/zh_CN.js',
        language: 'zh_CN',
        skin_url: '/tinymce/skins/ui/oxide', // 编辑器需要一个skin才能正常工作，所以要设置一个skin_url指向之前复制出来的skin文件
        plugins: 'code table lists wordcount', // 引入插件
        toolbar: 'table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | fontselect fontsizeselect lineheight forecolor backcolor bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | numlist bullist preview fullscreen', // 工具栏
        setup: (editor) => {
          editor.on('init', (e) => {
            console.log('The Editor has initialized.', e)
          })
          editor.on('drop', (e) => {
            this.drop(e)
          })
          editor.on('dragover', (e) => {
            this.dragOver(e)
          })
        }
      },
      fold: false,
      dics: [
        {
          key: '保证人名称',
          value: '$$GUARANTORNAME$$'
        },
        {
          key: '保证金额(大写)',
          value: '$$AMOUNT$$'
        },
        {
          key: '保证金额(小写)',
          value: '$$amount$$'
        }
      ]
    }
  },
  watch: {
    content: function (val) {
      console.log('content changed', val)
      this.value = val
    },
    value: function (val) {
      this.$emit('change', val)
    },
    dictionary: function (val) {
      this.dics = val
    }
  },
  mounted () {
    if (this.content) {
      this.value = this.content
    }
    if (this.dictionary) {
      this.dics = this.dictionary
    }
    tinymce.init({})
  },
  methods: {
    startDrag (e, text) {
      console.log(e, text)
      this.curBookmark = tinymce.activeEditor.selection.getBookmark()
      console.log(this.curBookmark)
      this.curDicText = text
    },
    dragOver (e) {
      e.preventDefault()
    },
    drop (e) {
      e.preventDefault()
      this.addToEditor(this.curDicText)
      this.curDicText = null
    },
    addToEditor (text) {
      tinymce.activeEditor.focus()
      if (this.curBookmark) {
        console.log(this.curBookmark)
        tinymce.activeEditor.selection.moveToBookmark(this.curBookmark)
      }
      tinymce.execCommand('mceInsertContent', false, text)
    }
  }
}
</script>

<style lang="less" scoped>
.html-editor {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  padding: 8px;
  .editor {
    flex: 1;
    position: relative;
    .trigger {
      position: absolute;
      top: 5px;
      right: -5px;
      width: 26px;
      color: #efefef;
      background: #999;
      border: 1px solid #e2e2e2;
      border-radius: 5px 0 0 5px;
      padding: 5px;
      z-index: 100;
      transition: all .2s linear;
      cursor: pointer;
      &:hover {
        color: #fff;
        background: #aaa;
        border: 1px solid #e2e2e2;
      }
    }
  }
  .dics {
    width: 240px;
    border: 1px solid #e2e2e2;
    background: #f2f2f2;
    padding: 16px;
    margin-left: 5px;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    transition: width .2s ease-in-out;
    .dic {
      padding: 5px 0;
      color: #777;
      cursor: pointer;
      &:hover {
        color: #444;
      }
    }
    &.fold {
      width: 0;
      padding: 16px 0;
    }
  }
}
</style>